import React from "react";
import logo from "../../../assets/images/logo.png";

const ReportCertificateFooter = ({
  reportData,
  selectedSections,
}: {
  reportData: any;
  selectedSections: { [key: string]: boolean };
}) => {
  const footerContainer = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "20px",
    fontSize: "12px",
  };

  const logoStyle = {
    width: "100%",
    objectFit: "contain",
  };

  return (
    <>
      <div style={footerContainer}>
        <div
          style={{
            marginTop: "40px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span
            style={{
              fontSize: "7px",
              color: "gray",
              marginLeft: "58px",
              marginBottom: "-5px",
            }}
          >
            Powered by
          </span>
          <img
            src={logo}
            alt="Footer Logo"
            style={{ ...logoStyle, width: "100px" }}
          />
        </div>

        {selectedSections?.FOOTER &&
          reportData?.medicalReportCertificateHeader?.footerEnable && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                {reportData?.medicalReportCertificateHeader
                  ?.stampServerImage && (
                  <div style={{ width: "60px", height: "60px" }}>
                    <img
                      src={`data:image/png;base64,${reportData?.medicalReportCertificateHeader?.stampServerImage}`}
                      alt="Stamp"
                      style={logoStyle}
                    />
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  {reportData?.medicalReportCertificateHeader
                    ?.signatureServerImage && (
                    <div style={{ width: "100px", height: "40px" }}>
                      <img
                        src={`data:image/png;base64,${reportData?.medicalReportCertificateHeader?.signatureServerImage}`}
                        alt="signature"
                        style={logoStyle}
                      />
                    </div>
                  )}

                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      marginTop: "5px",
                    }}
                  >
                    {
                      reportData?.medicalReportCertificateHeader
                        ?.consultingDoctorName
                    }
                  </div>
                  {reportData?.medicalReportCertificateHeader
                    ?.qualification && (
                    <div style={{ fontSize: "11px", color: "#555" }}>
                      (
                      {
                        reportData?.medicalReportCertificateHeader
                          ?.qualification
                      }
                      )
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
      </div>
    </>
  );
};

export default ReportCertificateFooter;
